export default "__VITE_ASSET__B7plyfm5__"